// import React, { useEffect, useState } from "react";
// import AdminAppBar from "../adminComponents/AdminAppBar";
// import KanbanBoard from "./KanbanBoard";
// import axios from "axios";

// const Pipeline = () => {
//   const [teams, setTeams] = useState([{ name: "All Team", id: "All Team" }]);

//   const [properties, setProperties] = useState([
//     { name: "All Property", id: "All Property" },
//   ]);

//   const [selectedTeam, setSelectedTeam] = useState("");

//   const [selectedProperty, setSelectedProperty] = useState("");

//   const userData = JSON.parse(localStorage.getItem("userData"));
//   const userRole = userData?.user?.role;

//   // const handleTeamChange = (e) => {
//   //   console.log(e);
//   //   if (e == "All Team") {
//   //     setSelectedTeam({});
//   //   }
//   //   teams.forEach((item) => {
//   //     if (item.teamId === e) {
//   //       setSelectedTeam({ name: item.name, id: item.teamId });
//   //     }
//   //   });
//   // };

//   // const handlePropertyChange = (e) => {
//   //   if (e == "All Property") {
//   //     console.log(e);
//   //     setSelectedProperty({});
//   //   }
//   //   properties.forEach((item) => {
//   //     if (item.id === e) {
//   //       setSelectedProperty({ name: item.name, id: item.id });
//   //     }
//   //   });
//   // };

//   useEffect(() => {
//     (async () => {
//       if (userRole === "Admin" || userRole === "CMO") {
//         try {
//           const response = await axios.get(
//             "https://value-realitty-backend-665385455484.asia-south1.run.app/api/v1/teams"
//           );
//           const data = response.data;
//           console.log(data);
//           setTeams([...teams, ...data]);
//         } catch (error) {
//           console.error("Error fetching teams:", error);
//           // Handle error if needed
//         }
//       } else if (userRole === "MD") {
//         setTeams(userData.teamId);
//         setSelectedTeam(userData.teamId[0]);
//       } else if (userRole === "BOD") {
//       }

//       try {
//         const response = await axios.get(
//           "https://value-realitty-backend-665385455484.asia-south1.run.app/api/v1/properties"
//         );
//         const data = response.data;
//         //console.log(data)
//         let propertiesDetails = [];
//         Object.keys(data).forEach((item) => {
//           propertiesDetails.push({ id: item, name: data[item].name });
//         });

//         setProperties([...properties, ...propertiesDetails]);
//       } catch (error) {
//         console.error("Error fetching properties:", error);
//         // Handle error if needed
//       }
//     })();
//   }, []);

//   const [tempSelectedTeam, setTempSelectedTeam] = useState("");
//   const [tempSelectedProperty, setTempSelectedProperty] = useState("");
//   const handleTeamChange = (e) => {
//     console.log(e);
//     setTempSelectedTeam(e);
//   };

//   const handlePropertyChange = (e) => {
//     console.log(e);
//     setTempSelectedProperty(e);
//   };
//   const applyFilter = () => {
//     // Apply the selected team and property filter

//     const selectedTeamObj =
//       teams.find((team) => team.teamId === tempSelectedTeam) || {};
//     const selectedPropertyObj =
//       properties.find((property) => property.id === tempSelectedProperty) || {};
//     console.log(selectedPropertyObj);
//     setSelectedTeam(selectedTeamObj.teamId);
//     setSelectedProperty(selectedPropertyObj.id);
//   };
//   React.useEffect(()=>{
//     setTimeout
//   })
//   return (
//     <div className="bg-appGrayBackground overflow-y-hidden ">
//       <AdminAppBar />
//       <div className="pt-8 px-10 xl:px-6 mt-20 flex justify-between  ">
//         <h1 className="text-4xl font-bold xl:text-3xl">Sales Pipeline</h1>

//         <div className="flex gap-5 ">
//           {userRole != "BOD" ? (
//             <div className=" flex items-center">
//               <select
//                 id="teamSelect"
//                 onChange={(e) => handleTeamChange(e.target.value)}
//                 className=" block w-[250px] py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
//               >
//                 {teams.map((team) => (
//                   <option key={team.teamId} value={team.teamId}>
//                     {team.name}
//                   </option>
//                 ))}
//               </select>
//             </div>
//           ) : (
//             ""
//           )}

//           <div className="flex items-center">
//             <select
//               id="teamSelect"
//               onChange={(e) => handlePropertyChange(e.target.value)}
//               className=" block w-[250px] py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
//             >
//               {properties.map((property) => (
//                 <option key={property.id} value={property.id}>
//                   {property.name}
//                 </option>
//               ))}
//             </select>
//           </div>
//           <button
//             onClick={applyFilter}
//             className="py-2 px-4 bg-customGreen text-white rounded-md focus:outline-none"
//           >
//             Apply
//           </button>
//         </div>
//       </div>

//       <div className=" ">
//         <KanbanBoard team={selectedTeam} property={selectedProperty} />
//       </div>
//     </div>
//   );
// };

// export default Pipeline;

import React, { useEffect, useState } from "react";
import AdminAppBar from "../adminComponents/AdminAppBar";
import KanbanBoard from "./KanbanBoard";
import ShimmerKanban from "./ShimmerKanban";
import teamService from "../Services/TeamService";
import propertyService from "../Services/PropertyService";
import PipelineFilter from "./PipelineFilter";
import { MdFilterListAlt } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import CustomButton from "../common/CustomButton";
import { teamIds } from "../../utils/storage";

const Pipeline = () => {
  const [teams, setTeams] = useState([{ name: "All Team", id: "All Team" }]);
  const [properties, setProperties] = useState([
    { name: "All Property", id: "All Property" },
  ]);
  const [users, SetUsers] = useState([]);
  const [selectedTeam, setSelectedTeam] = useState("");
  const  navigate = useNavigate()
  const [selectedProperty, setSelectedProperty] = useState("");
  const [selectedUser, setSelectedUser] = useState("");
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false); // Loading state

  const [selectedUserDetails, setSelectedUserDetails] = useState("");


  const userData = JSON.parse(localStorage.getItem("userData"));
  const userRole = userData?.user?.role;

  useEffect(() => {
    (async () => {
      try {
        if (userRole === "Admin" || userRole === "CMO") {
          const response = await teamService.getTeamName();
          setTeams([
            { name: "All Team", id: "All Team" },
            ...response.data.teams,
          ]);
        } else if (userRole === "MD" || userRole === "BOD") {
          setTeams(userData.teamId);
          setSelectedTeam(userData.teamId[0]);
        }

        const propResponse = await propertyService.getPropertiesName();
        setProperties([
          { name: "All Property", id: "All Property" },
          ...propResponse.data.properties,
        ]);


        const userResponse = await teamService.getUserName();
        SetUsers(userResponse.data.users);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    })();
  }, []);

  const [tempSelectedTeam, setTempSelectedTeam] = useState("" || teamIds);
  const [tempSelectedProperty, setTempSelectedProperty] =
    useState("");
  const [tempSelectedUser, setTempSelectedUser] = useState("");
  const handleTeamChange = (value) => {
    setTempSelectedTeam(value);
    setTempSelectedUser(null); 
  };
  
  const handlePropertyChange = (value) => {
    setTempSelectedProperty(value);
    setTempSelectedUser(null);
  };
  
  const handleUserChange = (value) => {
    setTempSelectedUser(value);

    const userName = users.find((item)=> item.id === value).name;
    console.log(userName)
    setSelectedUserDetails(userName)


    setTempSelectedTeam(null); 
    setTempSelectedProperty(null) 
  };
  
  const applyFilter = () => {

    

    const userId = tempSelectedUser !== "" ? tempSelectedUser : null;

  if (userId) {
    const path = userRole === "Admin" ? "/admin" : "/cmo";
    navigate(`${path}/pipline-user-deal`, {
      state: {
       userId: userId,
       userName : selectedUserDetails,
       userList : users,
      },
    });
    return; 
  }
    setSelectedTeam(tempSelectedTeam === "All Team" ? null : tempSelectedTeam);
    setSelectedProperty(
      tempSelectedProperty === "All Property" ? null : tempSelectedProperty
    );
 
    setVisible(false)
  };



  const handleFilterDeal = () => {
    setVisible(true);
  };

  
  return (
    <div className="bg-appGrayBackground overflow-y-hidden">
      <AdminAppBar />
      <div className="pt-4 px-10 xl:px-6 mt-20 flex justify-between">
        <h1 className="text-4xl font-bold xl:text-3xl">Sales Pipeline</h1>

        <div className="flex gap-5">
          {/* {userRole !== "BOD" && (
            <div className="flex items-center">
              <select
                id="teamSelect"
                value={tempSelectedTeam}
                onChange={(e) => handleTeamChange(e.target.value)}
                className="block w-[250px] py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              >
                {teams.map((team) => (
                  <option key={team.id} value={team.id}>
                    {team.name}
                  </option>
                ))}
              </select>
            </div>
          )} */}

          <div className="flex items-center">
            {/*   <select
              id="propertySelect"
              value={tempSelectedProperty}
              onChange={(e) => handlePropertyChange(e.target.value)}
              className="block w-[250px] py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
            >
              {properties.map((property) => (
                <option key={property.id} value={property.id}>
                  {property.name}
                </option>
              ))}
            </select>  */}
            <div className="flex items-center gap-4">
              <button
                onClick={handleFilterDeal}
                className="bg-white  justify-between text-base font-medium w-[131px] h-[50px] rounded-[10px]   flex items-center gap-3 text-customGreen py-2 px-4  hover:bg-appGreenHover transition duration-300"
              >
                Filters
                <MdFilterListAlt />
              </button>
            </div>
          </div>

          {/* <button
            onClick={applyFilter}
            className="py-2 px-4 bg-customGreen text-white rounded-md focus:outline-none"
          >
            {loading ? "Loading..." : "Apply"}
          </button> */}
        </div>
      </div>

      <div className="">{loading ? <ShimmerKanban /> : ""}</div>

      <div className="">
        {" "}
        <KanbanBoard
          team={selectedTeam}
          property={selectedProperty}
          setLoading={setLoading}
          userList={users}
        />
        <PipelineFilter
          visible={visible}
          onHide={() => setVisible(false)}
          teams={teams}
          properties={properties}
          users={users}
          handleApplyFilter={applyFilter}
          clearFilters={() => {
            setTempSelectedTeam("");
            setTempSelectedProperty("");
            setTempSelectedUser("");
            setSelectedTeam("");
            setSelectedProperty("");
            setSelectedUser("");
          }}
          
          selectedUser={tempSelectedUser}
          selectedTeam={tempSelectedTeam}
          selectedProperty={tempSelectedProperty}
          handleTeamChange={handleTeamChange}
          handlePropertyChange={handlePropertyChange}
          handleUserChange={handleUserChange}
          applyFilter={applyFilter}
          errors={{}}
        />
      </div>
    </div>
  );
};

export default Pipeline;
